import { includedMinuteItemRows, type MinuteItemRow } from './types'

/** Bir prensip kararına yüklenecek bekleyen dosyalar. */
export interface PendingUpload {
  principleId: number
  files: File[]
}

/** {@link planPendingPrincipleUploads} sonucu. */
export interface PendingUploadPlan {
  uploads: PendingUpload[]
  /**
   * Dosyası olduğu hâlde **bir id'ye bağlanamayan** satır var mı? true → hiçbir yere yüklenemez,
   * kullanıcı uyarılmalıdır. Sessiz kalmak en kötü sonuçtu: "kaydedildi" denip dosyalar yok oluyordu.
   */
  unmatched: boolean
}

/**
 * Tutanak kaydedildikten sonra, bekleyen prensip kararı dosyalarını sunucudan dönen id'lerle eşler (108).
 *
 * <p><b>Eşleme indis üzerindendir</b> ve bu yüzden hangi satırların <b>gövdeye girdiği</b> kritiktir:
 * sunucu id'leri gövdedeki sırayla döndürüyor, boş satırlar ise gövdeye hiç girmiyor. Ham satır
 * dizisiyle eşleme bir boş satırda kayar ve dosyayı <b>başka bir prensip kararına</b> yüklerdi — süzgeç
 * bu yüzden {@link includedMinuteItemRows} ile paylaşılıyor.
 *
 * <p>Saf fonksiyondur (ağ yok): asıl risk taşıyan mantık burada, test edilebilir hâlde durur.
 */
export function planPendingPrincipleUploads(
  rows: MinuteItemRow[],
  principleIds: number[] | undefined,
): PendingUploadPlan {
  const kept = includedMinuteItemRows(rows, false)
  const withFiles = (kept === 'invalid' ? rows : kept).filter((r) => (r.files?.length ?? 0) > 0)
  if (withFiles.length === 0) {
    return { uploads: [], unmatched: false }
  }
  // Süzgeç 'invalid' derse gövde zaten gönderilmemiştir; id de yoktur. Dosya varsa eşleşmemiş sayılır.
  if (kept === 'invalid' || principleIds == null) {
    return { uploads: [], unmatched: true }
  }

  const uploads: PendingUpload[] = []
  let unmatched = false
  for (const [i, row] of kept.entries()) {
    const files = row.files ?? []
    if (files.length === 0) continue
    const principleId = principleIds[i]
    // id yoksa (yanıt kısa geldi / alan hiç gelmedi) dosya HİÇBİR yere gidemez — sessizce atlama.
    if (principleId == null) {
      unmatched = true
      continue
    }
    uploads.push({ principleId, files })
  }
  return { uploads, unmatched }
}
